import { display, buildEndpointHost, mapValues } from '@datadog/browser-core';
const REMOTE_CONFIGURATION_VERSION = 'v1';
const SUPPORTED_FIELDS = [
    'applicationId',
    'service',
    'env',
    'version',
    'sessionSampleRate',
    'sessionReplaySampleRate',
    'defaultPrivacyLevel',
    'enablePrivacyForActionName',
    'traceSampleRate',
    'trackSessionAcrossSubdomains',
    'allowedTracingUrls',
    'allowedTrackingOrigins',
];
export async function fetchAndApplyRemoteConfiguration(initConfiguration) {
    const fetchResult = await fetchRemoteConfiguration(initConfiguration);
    if (!fetchResult.ok) {
        display.error(fetchResult.error);
        return;
    }
    return applyRemoteConfiguration(initConfiguration, fetchResult.value);
}
export function applyRemoteConfiguration(initConfiguration, rumRemoteConfiguration) {
    // intents:
    // - explicitly set each supported field to limit risk in case an attacker can create configurations
    // - check the existence in the remote config to avoid clearing a provided init field
    const appliedConfiguration = { ...initConfiguration };
    SUPPORTED_FIELDS.forEach((option) => {
        if (option in rumRemoteConfiguration) {
            appliedConfiguration[option] = resolveConfigurationProperty(rumRemoteConfiguration[option]);
        }
    });
    return appliedConfiguration;
}
function resolveConfigurationProperty(property) {
    if (Array.isArray(property)) {
        return property.map(resolveConfigurationProperty);
    }
    if (isObject(property)) {
        if (isSerializedOption(property)) {
            const type = property.rcSerializedType;
            switch (type) {
                case 'string':
                    return property.value;
                case 'regex':
                    return resolveRegex(property.value);
                default:
                    display.error(`Unsupported remote configuration: "rcSerializedType": "${type}"`);
                    return;
            }
        }
        return mapValues(property, resolveConfigurationProperty);
    }
    return property;
}
function isObject(property) {
    return typeof property === 'object' && property !== null;
}
function isSerializedOption(value) {
    return 'rcSerializedType' in value;
}
function resolveRegex(pattern) {
    try {
        return new RegExp(pattern);
    }
    catch (_a) {
        display.error(`Invalid regex in the remote configuration: '${pattern}'`);
    }
}
export async function fetchRemoteConfiguration(configuration) {
    let response;
    try {
        response = await fetch(buildEndpoint(configuration));
    }
    catch (_a) {
        response = undefined;
    }
    if (!response || !response.ok) {
        return {
            ok: false,
            error: new Error('Error fetching the remote configuration.'),
        };
    }
    const remoteConfiguration = await response.json();
    if (remoteConfiguration.rum) {
        return {
            ok: true,
            value: remoteConfiguration.rum,
        };
    }
    return {
        ok: false,
        error: new Error('No remote configuration for RUM.'),
    };
}
export function buildEndpoint(configuration) {
    if (configuration.remoteConfigurationProxy) {
        return configuration.remoteConfigurationProxy;
    }
    return `https://sdk-configuration.${buildEndpointHost('rum', configuration)}/${REMOTE_CONFIGURATION_VERSION}/${encodeURIComponent(configuration.remoteConfigurationId)}.json`;
}
//# sourceMappingURL=remoteConfiguration.js.map